import { FormattedMessage } from 'react-intl';

import { fantasy } from 'lib/glossary';

import { LineupActionCta } from '../LineupActionCta';

type Props = {
  url: string;
  nb: number;
  teamsCap?: number | null;
  short?: boolean;
};

export const LineupsCta = ({ url, nb, teamsCap, short = false }: Props) => {
  const canComposeMore = teamsCap ? nb < teamsCap : true;
  return (
    <LineupActionCta color={canComposeMore ? 'primary' : 'tertiary'} to={url}>
      {teamsCap ? (
        <FormattedMessage
          {...fantasy.lineupsRelativeCount}
          values={{ lineupsCount: nb, teamsCap }}
        />
      ) : (
        <>
          {short ? (
            nb
          ) : (
            <FormattedMessage
              {...fantasy.lineupsCount}
              values={{ lineupsCount: nb }}
            />
          )}
        </>
      )}
    </LineupActionCta>
  );
};
